const calcDate = (kind) => {
  if (kind === 'TODAY') return new Date()
  if (kind === 'YESTERDAY')
    return new Date(new Date().setDate(new Date().getDate() - 1))

  return new Date(new Date().setDate(new Date().getDate() + 1))
}

export default calcDate
